import { Button } from "react-bootstrap";
import { MdDescription, MdDelete, MdOpenInNew } from "react-icons/md";

export default function ActionButtons({
  row,
  onPodrobnostiClick,
  onDeleteClick,
  canDelete,
  onPovezavaClick,
}) {
  if (!onPodrobnostiClick) return null;

  const showDelete = onDeleteClick && (!canDelete || canDelete(row));
  const povezava = onPovezavaClick ? onPovezavaClick(row) : null;

  return (
    <div className="d-flex align-items-center gap-1">
      {onPodrobnostiClick && (
        <Button
          variant="outline-primary"
          className="border-0"
          size="sm"
          onClick={() => onPodrobnostiClick(row)}
        >
          <MdDescription size={16} />
        </Button>
      )}
      {povezava && (
        <Button
          variant="outline-secondary"
          className="border-0"
          size="sm"
          as="a"
          href={povezava}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MdOpenInNew size={16} />
        </Button>
      )}
      {showDelete && (
        <Button
          variant="outline-danger"
          className="border-0"
          size="sm"
          onClick={() => onDeleteClick(row)}
        >
          <MdDelete size={16} />
        </Button>
      )}
    </div>
  );
}
